const token = 'estore_token';
const expiredTime = 'estore_expired_time';

export const getEStoreToken = (): string => {
  const tokenData = localStorage.getItem(token);
  const expiredTimeToken = getExpiredTime();
  if (!expiredTimeToken || expiredTimeToken < Date.now()) {
    removeEStoreToken();
    return null;
  }
  return tokenData;
};

export const getExpiredTime = (): number | null => {
  const exp = localStorage.getItem(expiredTime);
  return exp ? Date.parse(exp) : null;
};

export const setEStoreToken = (value: string): void => {
  localStorage.setItem(token, value);
};

export const setExpiredTime = (value = 0): void => {
  const date = new Date();
  date.setSeconds(date.getSeconds() + value);
  localStorage.setItem(expiredTime, date.toLocaleString());
};

export const removeEStoreToken = (): void => {
  localStorage.removeItem(token);
  localStorage.removeItem(expiredTime);
};
